export default "__VITE_ASSET__2IIaNcf5__"